import { Component, inject, input, output, ChangeDetectionStrategy } from "@angular/core";
import { AiAdministrationResource } from "core/stages-client";
import { MainService } from "core/main.service";
import { ButtonComponent } from "common/buttons/button.component";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonsBottomComponent } from "common/buttons/buttons-bottom.component";
import { CustomAiPolicyComponent } from "common/disclaimer/ai-acknowledgements/custom-ai-policy.component";
import AiAcknowledgementsState = stages.userservice.core.AiAcknowledgementsState;

@Component({
	selector: "stages-ai-acknowledgements",
	templateUrl: "./ai-acknowledgements.component.html",
	styleUrls: ["./ai-acknowledgements.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ButtonComponent, TranslateModule, ButtonsBottomComponent, CustomAiPolicyComponent],
})
export class AiAcknowledgementsComponent {
	private mainService = inject(MainService);
	private aiAdministrationResource = inject(AiAdministrationResource);

	readonly acceptButtonClasses = input<string>("button sm save");

	readonly declineButtonClasses = input<string>("button sm cancel");

	readonly processVersion = input.required<string>();

	readonly acknowledgementsState = output<AiAcknowledgementsState>();

	async setAcknowledgementsState(state: AiAcknowledgementsState): Promise<void> {
		await this.aiAdministrationResource.putAiAcknowledgementState(state);
		this.acknowledgementsState.emit(state);
		await this.mainService.refreshApplication(this.processVersion());
	}
}
